var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Manual50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5722",
    d: "M6,10v28c0,2.2,1.8,4,4,4h28c2.2,0,4-1.8,4-4V10c0-2.2-1.8-4-4-4H10C7.8,6,6,7.8,6,10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC80",
    d: "M17 23h-4v-7c0-1.1.9-2 2-2l0 0c1.1 0 2 .9 2 2V23zM22 23h-4V12c0-1.1.9-2 2-2l0 0c1.1 0 2 .9 2 2V23zM27 23h-4V10c0-1.1.9-2 2-2l0 0c1.1 0 2 .9 2 2V23zM32 23h-4V13c0-1.1.9-2 2-2l0 0c1.1 0 2 .9 2 2V23zM29.8 38.2l-3.4-3.4 7.6-7.6c.9-.9 2.5-.9 3.4 0l0 0c.9.9.9 2.5 0 3.4L29.8 38.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC80",
    d: "M28,22c0,0.3-0.2,0.5-0.5,0.5S27,22.3,27,22h-4c0,0.3-0.2,0.5-0.5,0.5S22,22.3,22,22h-4c0,0.3-0.2,0.5-0.5,0.5S17,22.3,17,22h-4v10c0,4.4,3.6,8,8,8h4.2c3.7,0,6.8-3,6.8-6.8V22H28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Manual50);
export default __webpack_public_path__ + "static/media/icons8-manual-50.da7b05a4e894ec2ed03b280ac04a859e.svg";
export { ForwardRef as ReactComponent };